var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuelIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#0473EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408_5655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3901 11.3599L23.8901 9.85985C23.7436 9.71336 23.5063 9.71336 23.3599 9.85985C23.2134 10.0063 23.2134 10.2437 23.3599 10.3901L24.5947 11.625L23.3599 12.8598C23.2896 12.9302 23.25 13.0254 23.25 13.125V14.25C23.25 15.0773 23.9228 15.75 24.75 15.75V22.125C24.75 22.3319 24.5819 22.5 24.375 22.5C24.1681 22.5 24 22.3319 24 22.125V21.375C24 20.7546 23.4954 20.25 22.875 20.25H22.5V10.5C22.5 9.67271 21.8273 9 21 9H13.5C12.6728 9 12 9.67271 12 10.5V24C11.1727 24 10.5 24.6727 10.5 25.5V26.625C10.5 26.8323 10.6677 27 10.875 27H23.625C23.8323 27 24 26.8323 24 26.625V25.5C24 24.6728 23.3273 24 22.5 24V21H22.875C23.0819 21 23.25 21.1681 23.25 21.375V22.125C23.25 22.7454 23.7547 23.25 24.375 23.25C24.9954 23.25 25.5 22.7454 25.5 22.125V11.625C25.5 11.5254 25.4605 11.4302 25.3901 11.3599ZM21 15.3819C21 15.5892 20.8323 15.757 20.625 15.757H13.875C13.6677 15.757 13.5 15.5892 13.5 15.3819V10.875C13.5 10.6677 13.6677 10.5 13.875 10.5H20.625C20.8323 10.5 21 10.6677 21 10.875V15.3819Z",
    fill: "#0473EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_408_5655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelIcon);
export default __webpack_public_path__ + "static/media/fuel-icon.47f8cc1feb68de415e9b4069e0aee947.svg";
export { ForwardRef as ReactComponent };